// Which hue a series gets.
//
// The rule that matters: colour follows the ENTITY, not its rank. If
// "Kamraj Capsule" is blue today it is blue after the filter bar drops two
// other products, even though it is now the first bar rather than the
// third. Assigning by array index would repaint every survivor the moment
// a filter changed, and the reader would have to re-learn the chart.
//
// So each chart keeps a register of the slots it has handed out, for as
// long as the tab is open. A key already seen keeps its slot; a new one
// takes the next free slot.

const SLOTS = 8
const registry = new Map<string, Map<string, number>>()

/** Folded tails are always the last slot, so "Other" never wears a hue a real series might want. */
const OTHER = /^other(\s|$|\()/i

export function colorFor(chartId: string, key: string): string {
  if (OTHER.test(key)) return 'var(--series-8)'

  let seen = registry.get(chartId)
  if (!seen) registry.set(chartId, (seen = new Map()))

  let slot = seen.get(key)
  if (slot === undefined) {
    // Seven usable slots: the eighth is reserved for "Other" above. Past
    // seven the register wraps, which is the point at which the data
    // should have been folded server-side -- every query here caps its
    // series count before it gets this far.
    slot = seen.size % (SLOTS - 1)
    seen.set(key, slot)
  }
  return `var(--series-${slot + 1})`
}

/** A single-series chart is always slot 1 -- there is nothing to tell apart. */
export const SOLO = 'var(--series-1)'
